var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.023 4.69002C28.9786 2.92301 25.5201 1.9948 22 2.00002C10.954 2.00002 2 10.954 2 22C2 33.046 10.954 42 22 42C33.046 42 42 33.046 42 22C42 18.373 41.034 14.97 39.346 12.038",
    stroke: "#699BF7",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.95 14.05C29.95 14.05 26.562 23.095 25 24.657C24.2498 25.4072 23.2324 25.8287 22.1715 25.8287C21.1106 25.8287 20.0932 25.4072 19.343 24.657C18.5928 23.9069 18.1714 22.8894 18.1714 21.8286C18.1714 20.7677 18.5928 19.7502 19.343 19C20.905 17.438 29.95 14.05 29.95 14.05Z",
    stroke: "#699BF7",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.8b5e78468f6d737350fedaab4d0112dc.svg";
export { ForwardRef as ReactComponent };